module.exports = __webpack_public_path__ + "static/idris-815d901ce97e562f572917029411ecd6.jpg";